import i18next from 'i18next'
import { formatContactAsyncOption } from '../../../../api/contacts/formatters'
import contacts from '../../../../api/contacts/hooks'
import { store } from '../../../../store'
import { setFormFilter } from '../../../../store/formFilters'
import { renderCurrency } from '../../../../utils/property'
import { PROPERTY_STATUS, REAL_ESTATE_SERVICE } from '../../../constants'
import { baseAsyncSelectInput, baseDateInput, basePriceInput, baseSelectInput, baseTextInput } from '../../fieldTypes'
import { propertyTransactionsFields } from '../fields'

export const SItransactionFieldTypes = (appSettings, propertyServiceValue, requiredFields) => {
    const { t } = i18next

    return {
        [propertyTransactionsFields.PROPERTY_STATUS_ID]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.PROPERTY_STATUS_ID,
            label: t('app.common.status'),
            required: true,
            colProps: {
                sm: 12,
            },
            handleChange: (value, formik) => {
                store.dispatch(setFormFilter({ context: 'property', field: 'propertyStatusId', value }))

                if (value?.toString() !== PROPERTY_STATUS.RESERVED.toString()) {
                    formik.setFieldValue(`transactions.${propertyTransactionsFields.RESERVATION_DATE}`, '')
                }
            },
        },
        [propertyTransactionsFields.RESERVATION_DATE]: {
            ...baseDateInput,
            name: propertyTransactionsFields.RESERVATION_DATE,
            label: t('form.property.transaction.reservationDate.label'),
            tooltip: t('form.property.transaction.reservationDate.tooltip'),
            required: requiredFields.reserved,
            colProps: {
                sm: 12,
            },
        },
        [propertyTransactionsFields.CONTACT_ID]: {
            ...baseAsyncSelectInput,
            name: propertyTransactionsFields.CONTACT_ID,
            label: t('form.property.transaction.contact'),
            tooltip: t('form.property.transaction.contact.tooltip'),
            noLimit: true,
            searchCriteria: ['name'],
            required: requiredFields.soldRented || requiredFields.reserved,
            colProps: {
                sm: 6,
            },
            useEntityHook: contacts.GetContacts.useQuery,
            formatOption: formatContactAsyncOption,
        },
        [propertyTransactionsFields.PRICE_FINAL]: {
            ...basePriceInput,
            name: propertyTransactionsFields.PRICE_FINAL,
            label: t('form.property.transaction.priceFinal', { currency: renderCurrency(appSettings?.currency) }),
            required: requiredFields.soldRented,
        },
        [propertyTransactionsFields.COMMISION_SELLER]: {
            ...basePriceInput,
            name: propertyTransactionsFields.COMMISION_SELLER,
            label: propertyServiceValue === REAL_ESTATE_SERVICE.lease ? t('app.common.commissionLandlord') : t('app.common.commissionSeller'),
        },
        [propertyTransactionsFields.COMMISION_SELLER_TYPE_ID]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.COMMISION_SELLER_TYPE_ID,
            label: t('app.common.commissionType'),
        },
        [propertyTransactionsFields.PROPERTY_TRANSACTION_AGENT_ID]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.PROPERTY_TRANSACTION_AGENT_ID,
            label: t('app.common.agent'),
        },
        [propertyTransactionsFields.COMMISION_BUYER]: {
            ...basePriceInput,
            name: propertyTransactionsFields.COMMISION_BUYER,
            label: propertyServiceValue === REAL_ESTATE_SERVICE.lease ? t('app.common.commissionTenant') : t('app.common.commissionBuyer'),
        },
        [propertyTransactionsFields.COMMISION_BUYER_TYPE_ID]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.COMMISION_BUYER_TYPE_ID,
            label: t('app.common.commissionType'),
        },
        [propertyTransactionsFields.ADVANCE_AMOUNT]: {
            ...basePriceInput,
            name: propertyTransactionsFields.ADVANCE_AMOUNT,
            label: t('form.property.transaction.advanceAmount', { currency: renderCurrency(appSettings?.currency) }),
        },
        [propertyTransactionsFields.ADVANCE_DATE]: {
            ...baseDateInput,
            name: propertyTransactionsFields.ADVANCE_DATE,
            label: t('form.property.transaction.advanceDate'),
        },
        [propertyTransactionsFields.CONCLUSION_PLACE]: {
            ...baseTextInput,
            name: propertyTransactionsFields.CONCLUSION_PLACE,
            label: t('app.common.conclusionPlace'),
            required: requiredFields.soldRented,
        },
        [propertyTransactionsFields.CONCLUSION_DATE]: {
            ...baseDateInput,
            name: propertyTransactionsFields.CONCLUSION_DATE,
            label: t('app.common.conclusionDate'),
            required: requiredFields.soldRented,
        },
        [propertyTransactionsFields.FINAL_PAYMENT_DATE]: {
            ...baseDateInput,
            name: propertyTransactionsFields.FINAL_PAYMENT_DATE,
            label: t('form.property.transaction.finalPaymentDate'),
        },
        [propertyTransactionsFields.PROPERTY_TRANSACTION_AGENT_ID]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.PROPERTY_TRANSACTION_AGENT_ID,
            label: t('app.common.agent'),
        },
        [propertyTransactionsFields.PROPERTY_CADASTRAL_MUNCIPALITY]: {
            ...baseSelectInput,
            name: propertyTransactionsFields.PROPERTY_CADASTRAL_MUNCIPALITY,
            label: t('app.common.cadastralMunicipality'),
        },
        [propertyTransactionsFields.PROPERTY_CADASTRAL_PARCEL_NO]: {
            ...baseTextInput,
            name: propertyTransactionsFields.PROPERTY_CADASTRAL_PARCEL_NO,
            label: t('app.common.property.cadastralParcel'),
        },
        [propertyTransactionsFields.PROPERTY_BUILDING_NUMBER]: {
            ...baseTextInput,
            name: propertyTransactionsFields.PROPERTY_BUILDING_NUMBER,
            label: t('app.property.transaction.buildingNumber'),
        },
        [propertyTransactionsFields.PROPERTY_BUILDING_PART_NUMBER]: {
            ...baseTextInput,
            name: propertyTransactionsFields.PROPERTY_BUILDING_PART_NUMBER,
            label: t('app.property.transaction.buildingPartNumber'),
        },
    }
}
